<mat-card>{{ data }}</mat-card>
